var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FootBottom",style:({ 'background-image':'url('+_vm.domain+_vm.logoImg+')'}),on:{"click":_vm.btn1}})
}
var staticRenderFns = []

export { render, staticRenderFns }